import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as Nope from 'lib/utils/validation/Nope'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { Field, Form } from 'formik'
import classNames from 'classnames'
import { NOTIFICATION_TYPE } from 'components/Notifications/Notifications'
import { newNotification } from 'lib/utils/store/notifications'

import ExtendedFormik from 'components/Forms/ExtendedFormik'
import Icon from 'components/Icon'
import Button from 'components/UI/Button'
import FormElementGroup from 'components/FormElements/FormElementGroup'
import Input from 'components/Forms/FormElements/Input'
import TextArea from 'components/Forms/FormElements/TextArea'

import './vehicle-profile-share-with-email.pcss'

const VehicleProfileShareWithEmail = ({ t, vehicleProfileShareLogic, shareLinkId }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div
            className={classNames(
                'vehicle-profile-share-with-email',
                { 'vehicle-profile-share-with-email--open': isOpen }
            )}
        >
            <div className="vehicle-profile-share-with-email__actions">
                <Button
                    className="button button--tertiary"
                    trackName="shareWithEmail"
                    onClick={() => setIsOpen(true)}
                >
                    <Icon fa name={['fas', 'envelope']} size="m" />
                    {t('vehicleProfile:share.withEmail.shareWithEmail')}
                </Button>
            </div>
            {isOpen && (
                <div className="vehicle-profile-share-with-email__form">
                    <ExtendedFormik
                        id="vehicle-profile-share-with-email-form"
                        initialValues={{
                            recipientEmail: '',
                            message: '',
                        }}
                        validationSchema={Nope.schema({
                            recipientEmail: Nope.email()
                                .required('formElements:validation.required'),
                            message: Nope.message(),
                        })}
                        onSubmit={async (values, actions) => {
                            await vehicleProfileShareLogic.sendVehicleProfileShareEmail(shareLinkId, values.recipientEmail, values.message)
                                .then(res => {
                                    if (res.data && res.data.shareVehicleProfileLink) {
                                        newNotification(
                                            NOTIFICATION_TYPE.SUCCESS,
                                            '',
                                            t('vehicleProfile:share.withEmail.messageSent', { email: values.recipientEmail })
                                        )
                                        actions.resetForm()
                                        setIsOpen(false)
                                    }
                                })
                                .catch((error) => {
                                    actions.setSubmitting(false)
                                    return Promise.reject(error)
                                })
                        }}
                    >
                        {({ isSubmitting, dirty }) => (
                            <Form noValidate>
                                <FormElementGroup>
                                    <Field
                                        name="recipientEmail"
                                        label={t('vehicleProfile:share.withEmail.recipientEmail')}
                                        component={Input}
                                    />
                                    <Field name="message">
                                        {props => (
                                            <TextArea
                                                label={t('vehicleProfile:share.withEmail.message')}
                                                rows="3"
                                                {...props}
                                            />
                                        )}
                                    </Field>
                                </FormElementGroup>
                                <Button
                                    className="button vehicle-profile-share-with-email__submit"
                                    trackName="sendEmail"
                                    loading={isSubmitting}
                                    disabled={isSubmitting}
                                >
                                    {t('common:submit')}
                                </Button>
                            </Form>
                        )}
                    </ExtendedFormik>
                </div>
            )}
        </div>
    )
}

VehicleProfileShareWithEmail.propTypes = {
    vehicleProfileShareLogic: PropTypes.object.isRequired,
    shareLinkId: PropTypes.string.isRequired,
}

export default flowRight(
    withTranslationCustom(['common', 'vehicleProfile']),
)(VehicleProfileShareWithEmail)
